<template>
  <div :class="$store.state.menu.finalizacaoPedido == true ? $vssWidth > 1400 ? 'content' : 'content2' : 'content'">
    <div v-if="$store.state.menu.finalizacaoPedido == true" class="etapas">
      <input type="submit" class="btn-ativo" value="1" />
      <div class="linha"></div>
      <input type="submit" class="btn-inativo" value="2" />
      <div class="linha"></div>
      <input type="submit" class="btn-inativo" value="3" />
    </div>

    <div v-if="$store.state.menu.finalizacaoPedido == true" class="etapas-titulo">
      <p class="p-ativo primeiro">Etapa 1:<br>login ou cadastro</p>
      <div class="linha-espaco"></div>
      <p class="p-inativo">Etapa 2:<br>pagamento</p>
      <div class="linha-espaco"></div>
      <p class="p-inativo ultimo">Etapa 3:<br>concluído</p>
    </div>

    <div class="cadastro">
      <div v-if="mostrarLoginExterno == true">
        <button class="bt-google" @click="loginExterno('Google')"><i class="fab fa-google"></i>  Acesse com Google</button>
       <button class="bt-facebook" @click="loginExterno('Facebook')"><i class="fab fa-facebook"></i>  Acesse com Facebook</button>
      </div>
      <p class="titulo">DADOS PESSOAIS</p>
      <p v-if="$store.state.usuario.usuarioProvisorio && mostrarLoginExterno == false" class="descricao">Olá {{$store.state.usuario.usuarioProvisorio.PrimeiroNome}}, como é o seu 1º acesso no novo sistema, confirme seus dados!</p>
      <form @submit.prevent="cadastro">
      <div class="cadastro-form">
        <div v-if="$store.state.usuario.loginGoogleFacebook === false" class="form-left">
          <p class="label">Nome: *</p>
          <input v-model="formCadastro.nomeCompleto" type="text" name="nome" required placeholder="digite seu nome">
        </div>
        <div v-else class="form-left">
          <p class="label">Nome: *</p>
          <span v-if="formCadastro.nomeCompleto"><b>{{formCadastro.nomeCompleto}}</b></span>
        </div>
        <div v-if="$store.state.usuario.loginGoogleFacebook === false" class="form-right">
          <p class="label">E-mail: *</p>
          <input ref="email" v-model="formCadastro.email" type="email" name="email" required placeholder="digite seu e-mail">
        </div>
        <div v-else class="form-right">
          <p class="label">E-mail: *</p>
          <span v-if="formCadastro.email"><b>{{formCadastro.email}}</b></span>
        </div>
        <div v-if="$store.state.usuario.loginGoogleFacebook === false" class="form-left">
          <p class="label">Senha: *</p>
          <input ref="senha" v-model="formCadastro.password" type="password" name="senha" placeholder="crie a sua senha" required>
        </div>
        <div v-if="$store.state.usuario.loginGoogleFacebook === false" class="form-right">
         <p class="label">Confirme sua senha: *</p>
          <input ref="senhaConfirmar" v-model="formCadastro.passwordConfirmado" type="password" name="senha" placeholder="confirme a sua senha" required>
        </div>
        <div class="form-left">
          <p class="label">Celular: *</p>
          <input v-model="formCadastro.telefone" v-mask="'(##) #####-####'" type="text" name="celular" required placeholder="(00) 00000-0000">
        </div>
        <div class="form-right">
          <p class="label">CPF: *</p>
          <input ref="cpf" v-model="formCadastro.cpf" v-mask="'###.###.###-##'" required type="text" name="cpf" placeholder="000.000.000-00">
        </div>
      </div>
      <p class="titulo margin-top">ENDEREÇO / LOCALIZAÇÃO</p>
      <div class="cadastro-form">
        <div class="form-left">
          <p class="label">Cep: *</p>
          <input v-model="formCadastro.enderecoCep" @keyup="buscarCep()" v-mask="'#####-###'" required type="text" name="cep" placeholder="00000-000" class="cep">
        </div>
        <div class="form-right">
        </div>
        <div class="form-spam">
          <p class="label">Rua / Avenida / Logradouro: *</p>
          <input v-model="formCadastro.enderecoRua" type="rua" name="rua" required placeholder="digite o nome da rua, avenida ou logradouro">
        </div>
        <div class="form-left">
          <p class="label">Número: *</p>
          <input v-model="formCadastro.enderecoNumero" type="text" name="senha" placeholder="digite o número da residência" required>
        </div>
        <div class="form-right">
         <p class="label">Complemento:</p>
          <input v-model="formCadastro.enderecoComplemento" type="text" name="complemento" placeholder="complemento do endereço">
        </div>
        <div class="form-left">
         <p class="label">Bairro: *</p>
          <input v-model="formCadastro.enderecoBairro" type="text" name="bairro" placeholder="digite o bairro" required>
        </div>
        <div class="form-right">
          <p class="label">Cidade: *</p>
          <input v-model="formCadastro.enderecoCidade" type="text" name="cidade" placeholder="digite a cidade" required>
        </div>
        <div class="form-left">
          <p class="label">UF: *</p>
          <select required v-model="formCadastro.enderecoUF" class="uf">
            <option v-for="estado in estados" :key="estado" :value="estado">{{estado}}</option>
          </select>
        </div>
        </div>
      <button type="submit" class="bt-cadastro">Confirmar cadastro</button>
      </form>
    </div>
  </div>
</template>

<script>
import { dbCadastro, auth, googleProvider, facebookProvider } from '@/firebase_cadastro.js'
import { mapActions } from 'vuex'
import VueScreenSize from 'vue-screen-size'
import axios from 'axios'
import CPF from 'cpf'

export default {
  name: 'Cadastrar',
  props: ['mostrarLoginExterno'],
  mixins: [VueScreenSize.VueScreenSizeMixin],
  data: function () {
    return {
      usuario: null,
      estados: [
        'AC',
        'AL',
        'AP',
        'AM',
        'BA',
        'CE',
        'DF',
        'ES',
        'GO',
        'MA',
        'MT',
        'MS',
        'MG',
        'PA',
        'PB',
        'PR',
        'PE',
        'PI',
        'RJ',
        'RN',
        'RS',
        'RO',
        'RR',
        'SC',
        'SP',
        'SE',
        'TO'
      ],
      formLogin: {
        email: null,
        password: null
      },
      formCadastro: {
        email: null,
        password: null,
        passwordConfirmado: null,
        telefone: null,
        nomeCompleto: null,
        enderecoCep: null,
        enderecoRua: null,
        enderecoNumero: null,
        enderecoBairro: null,
        enderecoComplemento: null,
        enderecoCidade: null,
        enderecoUF: null,
        cpf: null
      }
    }
  },
  destroyed () {
    this.limparFinalizarCompraMenu()
    this.limparLoginExterno()
  },
  created () {
    this.getUsuarioProvisorio()
  },
  methods: {
    ...mapActions('usuario', ['usuarioAtual', 'usuarioProvisorio', 'limparLoginGoogleFacebook', 'loginGoogleFacebook', 'loginCpf']),
    ...mapActions('menu', ['finalizacaoPedido']),
    ...mapActions('configuracoes', ['loading']),
    async buscarCep () {
      var cepFormatado = this.formCadastro.enderecoCep.replace(/\./g, '').replace('-', '')
      if (cepFormatado.length === 8) {
        let loader = this.$loading.show({
          container: null,
          fullPage: true,
          color: '#F85E28',
          loader: 'spinner',
          width: 100,
          height: 100,
          backgroundColor: '#ffffff',
          opacity: 0.5,
          zIndex: 999
        })
        axios({
          'method': 'get',
          'url': `https://viacep.com.br/ws/${cepFormatado}/json/`
        }).then((response) => {
          this.formCadastro.cep = response.data.cep
          this.formCadastro.enderecoRua = response.data.logradouro
          this.formCadastro.enderecoBairro = response.data.bairro
          this.formCadastro.enderecoCidade = response.data.localidade
          this.formCadastro.enderecoUF = response.data.uf
          this.formCadastro.enderecoComplemento = response.data.complemento
        })
        loader.hide()
      }
    },
    limparFinalizarCompraMenu () {
      this.finalizacaoPedido(false)
    },
    focarCpf () {
      this.$refs.cpf.focus()
    },
    focarSenha () {
      this.$refs.senha.focus()
    },
    focarSenhaConfirmar () {
      this.$refs.senhaConfirmar.focus()
    },
    focarEmail () {
      this.$refs.email.focus()
    },
    loginExterno (formaLogin) {
      auth.signInWithPopup(formaLogin === 'Google' ? googleProvider : facebookProvider).then((data) => {
        dbCadastro.collection('Clientes').doc(data.user.email).get().then((doc) => {
          if (doc.exists) {
            this.usuario = {
              id: data.user.uid,
              NomeCompleto: data.user.displayName,
              PrimeiroNome: data.user.displayName.split(' ')[0],
              UltimoNome: data.user.displayName.split(' ')[1],
              Email: data.user.email,
              Cpf: doc.data().Cpf,
              Telefone: doc.data().Telefone,
              Token: data.user.xa,
              Foto: data.user.photoURL,
              EnderecoCep: doc.data().EnderecoCep,
              EnderecoRua: doc.data().EnderecoRua,
              EnderecoNumero: doc.data().EnderecoNumero,
              EnderecoBairro: doc.data().EnderecoBairro,
              EnderecoComplemento: doc.data().EnderecoComplemento,
              EnderecoCidade: doc.data().EnderecoCidade,
              EnderecoUF: doc.data().EnderecoUF,
              FormaLogin: formaLogin
            }
            if (doc.data().PrimeiroAcesso === true) {
              dbCadastro.collection('Clientes').doc(data.user.email).update({
                FormaLogin: formaLogin
              })
              this.usuarioAtual(this.usuario)
              localStorage.setItem('usuarioAtual', JSON.stringify(this.usuario))
              this.rotaAposLogin()
            } else {
              this.$fire({
                title: 'Olá ' + data.user.displayName,
                text: 'Preencha o formulário para concluir o seu cadastro',
                type: 'success'
              })
              this.loginGoogleFacebook(true)
              this.usuarioProvisorio(this.usuario)
              this.formCadastro.email = data.user.email
              this.formCadastro.nomeCompleto = data.user.displayName
              if (this.$route.name !== 'Cadastrar') {
                this.$route.push({name: 'Cadastrar'})
              }
            }
          } else {
            this.$fire({
              title: 'Olá ' + data.user.displayName,
              text: 'Preencha o formulário para concluir o seu cadastro',
              type: 'success'
            })
            this.usuario = {
              id: data.user.uid,
              NomeCompleto: data.user.displayName,
              PrimeiroNome: data.user.displayName.split(' ')[0],
              UltimoNome: data.user.displayName.split(' ')[1],
              Email: data.user.email,
              Token: data.user.xa,
              Foto: data.user.photoURL,
              FormaLogin: formaLogin,
              PrimeiroAcesso: false
            }
            dbCadastro.collection('Clientes').doc(data.user.email).set(this.usuario)
            this.formCadastro.email = data.user.email
            this.formCadastro.nomeCompleto = data.user.displayName
            this.usuarioProvisorio(this.usuario)
            if (this.$route.name !== 'Cadastrar') {
              this.$route.push({name: 'Cadastrar'})
            }
          }
        }).catch((error) => {
          console.log(error)
        })
      }).catch((error) => {
        switch (error.code) {
          case 'auth/wrong-password':
            this.$fire({
              title: 'Não foi possível realizar o login',
              text: 'A Senha informada está incorreta.',
              type: 'error'
            })
            break
          case 'auth/user-not-found':
            this.$fire({
              title: 'Não foi possível realizar o login',
              text: 'Não há registro de usuário para esse identificador.',
              type: 'error'
            })
            break
          case 'auth/account-exists-with-different-credential':
            this.$fire({
              title: 'O seu e-mail está cadastrado para acesso com o Google',
              text: 'Para acessar o sistema com o login do Google, basta clicar em "OK".',
              type: 'warning',
              showCancelButton: true,
              cancelButtonText: 'Cancelar'
            }).then(r => {
              if (r.value) {
                this.loginExterno('Google')
              }
            })
            break
        }
      })
    },
    rotaAposLogin () {
      if (this.$store.state.menu.finalizacaoPedido === true) {
        this.$router.push({name: 'Pagamento', params: {id: this.$store.state.carrinho.idCarrinho}})
      } else {
        this.$router.push({name: 'Minha Conta'})
      }
    },
    limparLoginExterno () {
      this.limparLoginGoogleFacebook()
    },
    getUsuarioProvisorio () {
      this.formCadastro.email = this.$store.state.usuario.usuarioProvisorio.Email != null ? this.$store.state.usuario.usuarioProvisorio.Email : null
      this.formCadastro.telefone = this.$store.state.usuario.usuarioProvisorio.Telefone != null ? this.$store.state.usuario.usuarioProvisorio.Telefone : null
      this.formCadastro.nomeCompleto = this.$store.state.usuario.usuarioProvisorio.NomeCompleto != null ? this.$store.state.usuario.usuarioProvisorio.NomeCompleto : null
      this.formCadastro.enderecoCep = this.$store.state.usuario.usuarioProvisorio.EnderecoCep != null ? this.$store.state.usuario.usuarioProvisorio.EnderecoCep : null
      this.formCadastro.enderecoRua = this.$store.state.usuario.usuarioProvisorio.EnderecoRua != null ? this.$store.state.usuario.usuarioProvisorio.EnderecoRua : null
      this.formCadastro.enderecoNumero = this.$store.state.usuario.usuarioProvisorio.EnderecoNumero != null ? this.$store.state.usuario.usuarioProvisorio.EnderecoNumero : null
      this.formCadastro.enderecoBairro = this.$store.state.usuario.usuarioProvisorio.EnderecoBairro != null ? this.$store.state.usuario.usuarioProvisorio.EnderecoBairro : null
      this.formCadastro.enderecoComplemento = this.$store.state.usuario.usuarioProvisorio.EnderecoComplemento != null ? this.$store.state.usuario.usuarioProvisorio.EnderecoComplemento : null
      this.formCadastro.enderecoCidade = this.$store.state.usuario.usuarioProvisorio.EnderecoCidade != null ? this.$store.state.usuario.usuarioProvisorio.EnderecoCidade : null
      this.formCadastro.enderecoUF = this.$store.state.usuario.usuarioProvisorio.EnderecoUF != null ? this.$store.state.usuario.usuarioProvisorio.EnderecoUF : null
      this.formCadastro.cpf = this.$store.state.usuario.usuarioProvisorio.Cpf != null ? this.$store.state.usuario.usuarioProvisorio.Cpf : null
    },
    async cadastro () {
      this.loading(true)
      if (this.$store.state.usuario.loginGoogleFacebook === false) {
        if (CPF.isValid(this.formCadastro.cpf)) {
          await dbCadastro.collection('Clientes').where('Cpf', '==', this.formCadastro.cpf).where('PrimeiroAcesso', '==', true).limit(1).get().then(async (querySnapshot) => {
            if (querySnapshot.empty) {
              if (this.formCadastro.passwordConfirmado === this.formCadastro.password) {
                await auth.createUserWithEmailAndPassword(this.formCadastro.email, this.formCadastro.passwordConfirmado)
                  .then(data => {
                    this.usuario = {
                      NomeCompleto: this.formCadastro.nomeCompleto,
                      PrimeiroNome: this.formCadastro.nomeCompleto.split(' ')[0],
                      UltimoNome: this.formCadastro.nomeCompleto.split(' ')[1],
                      Telefone: this.formCadastro.telefone,
                      Email: this.formCadastro.email,
                      EnderecoCep: this.formCadastro.enderecoCep,
                      EnderecoRua: this.formCadastro.enderecoRua,
                      EnderecoNumero: this.formCadastro.enderecoNumero,
                      EnderecoBairro: this.formCadastro.enderecoBairro,
                      EnderecoComplemento: this.formCadastro.enderecoComplemento,
                      EnderecoCidade: this.formCadastro.enderecoCidade,
                      EnderecoUF: this.formCadastro.enderecoUF,
                      Cpf: this.formCadastro.cpf,
                      id: data.user.uid,
                      Token: data.user.xa,
                      Foto: data.user.photoURL,
                      FormaLogin: 'Convencional',
                      PrimeiroAcesso: true
                    }
                  })
                  .catch(async (error) => {
                    switch (error.code) {
                      case 'auth/email-already-in-use':
                        await dbCadastro.collection('Clientes').doc(this.formCadastro.email).get().then((doc) => {
                          if (doc.data().FormaLogin !== null) {
                            this.$fire({
                              title: 'Não foi possível realizar o cadastro',
                              text: 'O e-mail ' + doc.data().Email + ' já está cadastrado com o acesso via ' + doc.data().FormaLogin,
                              type: 'error',
                              showCancelButton: true,
                              cancelButtonText: 'Cancelar',
                              confirmButtonText: 'Fazer Login'
                            }).then(r => {
                              if (r.value) {
                                this.$router.push({name: 'Login'})
                              } else {
                                setTimeout(() => this.focarEmail(), 500)
                              }
                            })
                          }
                        })
                        break
                      case 'auth/invalid-password':
                        this.$fire({
                          title: 'Não foi possível realizar o cadastro',
                          text: 'A senha informada precisa ter pelo menos 6 caracteres.',
                          type: 'error'
                        }).then(r => {
                          if (r.value) {
                            setTimeout(() => this.focarSenha(), 500)
                          }
                        })
                        break
                      case 'auth/weak-password':
                        this.$fire({
                          title: 'Não foi possível realizar o cadastro',
                          text: 'A senha informada precisa ter pelo menos 6 caracteres.',
                          type: 'error'
                        }).then(r => {
                          if (r.value) {
                            setTimeout(() => this.focarSenha(), 500)
                          }
                        })
                        break
                      case 'auth/account-exists-with-different-credential':
                        await dbCadastro.collection('Clientes').doc(this.formCadastro.email).get().then((doc) => {
                          this.$fire({
                            title: 'Não foi possível realizar o cadastro',
                            text: 'E-mail informado já está associado a outra conta com o acesso via ' + doc.data().FormaLogin,
                            type: 'error',
                            showCancelButton: true,
                            cancelButtonText: 'Cancelar',
                            confirmButtonText: 'Fazer Login'
                          }).then(r => {
                            if (r.value) {
                              this.$router.push({name: 'Login'})
                            } else {
                              setTimeout(() => this.focarEmail(), 500)
                            }
                          })
                        })
                        break
                    }
                  })
              } else {
                this.$fire({
                  title: 'Não foi possível realizar o cadastro',
                  text: 'As senhas digitadas não são correspondentes.',
                  type: 'error'
                })
                  .then(r => {
                    if (r.value) {
                      setTimeout(() => this.focarSenhaConfirmar(), 500)
                    }
                  })
              }
            } else {
              querySnapshot.forEach((doc) => {
                var mensagem = ''
                if (doc.data().FormaLogin != null) {
                  mensagem = 'CPF informado já está cadastrado associado ao e-mail ' + doc.data().Email + ' com o acesso via ' + doc.data().FormaLogin
                } else {
                  mensagem = 'CPF informado já está cadastrado associado ao e-mail ' + doc.data().Email
                }
                this.$fire({
                  title: 'Não foi possível realizar o cadastro',
                  text: mensagem,
                  type: 'error',
                  showCancelButton: true,
                  cancelButtonText: 'Cancelar',
                  confirmButtonText: 'Fazer Login'
                }).then(r => {
                  if (r.value) {
                    this.$router.push({name: 'Login'})
                  } else {
                    setTimeout(() => this.focarCpf(), 500)
                  }
                })
              })
            }
          })
        } else {
          this.$fire({
            title: 'Não foi possível realizar o cadastro',
            text: 'CPF informado é inválido.',
            type: 'error'
          }).then(r => {
            setTimeout(() => this.focarCpf(), 500)
          })
        }
      } else {
        this.usuario = {
          NomeCompleto: this.formCadastro.nomeCompleto,
          PrimeiroNome: this.formCadastro.nomeCompleto.split(' ')[0],
          UltimoNome: this.formCadastro.nomeCompleto.split(' ')[1],
          Telefone: this.formCadastro.telefone,
          Email: this.formCadastro.email,
          EnderecoCep: this.formCadastro.enderecoCep,
          EnderecoRua: this.formCadastro.enderecoRua,
          EnderecoNumero: this.formCadastro.enderecoNumero,
          EnderecoBairro: this.formCadastro.enderecoBairro,
          EnderecoComplemento: this.formCadastro.enderecoComplemento,
          EnderecoCidade: this.formCadastro.enderecoCidade,
          EnderecoUF: this.formCadastro.enderecoUF,
          Cpf: this.formCadastro.cpf,
          id: this.$store.state.usuario.usuarioProvisorio.id,
          Token: this.$store.state.usuario.usuarioProvisorio.Token,
          Foto: this.$store.state.usuario.usuarioProvisorio.Foto,
          FormaLogin: this.$store.state.usuario.usuarioProvisorio.FormaLogin,
          PrimeiroAcesso: true
        }
      }
      if (this.usuario != null) {
        if (CPF.isValid(this.formCadastro.cpf)) {
          await dbCadastro.collection('Clientes').where('Cpf', '==', this.formCadastro.cpf).where('PrimeiroAcesso', '==', true).limit(1).get().then(async (querySnapshot) => {
            if (querySnapshot.empty) {
              await dbCadastro.collection('Clientes').doc(this.formCadastro.email).set(this.usuario)
              localStorage.setItem('usuarioAtual', JSON.stringify(this.usuario))
              this.usuarioAtual(this.usuario)
              this.limparLoginGoogleFacebook()
              this.$fire({
                title: 'Olá ' + this.usuario.PrimeiroNome,
                text: 'Cadastro realizado com sucesso!',
                type: 'success'
              })
              if (this.$store.state.menu.finalizacaoPedido === true) {
                this.$router.push({name: 'Pagamento'})
              } else {
                this.$router.push({name: 'Minha Conta'})
              }
            } else {
              querySnapshot.forEach((doc) => {
                var mensagem = ''
                if (doc.data().FormaLogin != null) {
                  mensagem = 'CPF informado já está cadastrado associado ao e-mail ' + doc.data().Email + ' com o acesso via ' + doc.data().FormaLogin
                } else {
                  mensagem = 'CPF informado já está cadastrado associado ao e-mail ' + doc.data().Email
                }
                this.$fire({
                  title: 'Não foi possível realizar o cadastro',
                  text: mensagem,
                  type: 'error',
                  showCancelButton: true,
                  cancelButtonText: 'Cancelar',
                  confirmButtonText: 'Fazer Login'
                }).then(r => {
                  if (r.value) {
                    this.$router.push({name: 'Login'})
                  } else {
                    setTimeout(() => this.focarCpf(), 500)
                  }
                })
              })
            }
          }
          )
        } else {
          this.$fire({
            title: 'Não foi possível realizar o cadastro',
            text: 'CPF informado é inválido.',
            type: 'error'
          }).then(r => {
            setTimeout(() => this.focarCpf(), 500)
          })
        }
      }
      this.loading(false)
    }
  }
}
</script>

<style scoped>
.content, .content2 {
  max-width: 1174px;
  margin: 0 auto;
  padding: 20px;
  display: grid;
  grid-template-columns: 1fr;
  gap: 20px;
  grid-template-areas:
    "etapas"
    "etapas-titulo"
    "cadastro"
    "endereco"
}

.content2 {
  max-width: 1000px;
  padding: 0 200px 0 0;
}

@media (max-width: 960px) {
  .content, .content2 {
    margin: 0;
    padding: 20px;
    grid-template-columns: 1fr;
    grid-template-columns: 100%;
    grid-template-areas:
      "etapas"
      "etapas-titulo"
      "cadastro"
      "endereco"
  }
}

.bt-facebook {
 background: #4266AE;
 margin: 10px 0px;
 width: 60%;
}

.bt-login:hover {
  background: #186B65;
  transform: scale(1.1);
}

.bt-google {
  background: #4286F5;
  margin: 10px 0px;
  width: 60%;
}

.bt-google:hover {
  background: #4286F5;
}

.titulo {
  font-size: 1.2rem;
  color: #2E9189;
  font-weight: 600;
  border-bottom: 1px solid #2E9189;
  padding: 5px 0;
  margin: 0 0 15px 0;
}

.form {
  margin: 0 auto;
  padding: 0 20px;
}

.form p {
  padding: 0 5%;
  color: #333;
}

.label {
  text-align: left;
}

.form button {
  margin: 10px auto;
}

button {
  color: #fff;
  padding: 10px 20px;
  border-radius: 4px;
  border: 0;
  font-size: 1.05em;
  cursor: pointer;
  box-shadow: 0 4px 8px rgba(30, 60, 90, 0.2);
  transition: all 0.3s;
}

button:hover {
  transform: scale(1.1);
}

.bt-login {
  background: #2E9189;
}

.bt-login:hover {
  background: #186B65;
}

/* CADASTRO */
.cadastro {
  grid-area: cadastro;
}

.endereco {
  grid-area: endereco;
}

.cadastro, .endereco {
  width: 60%;
  justify-self: center;
  background: #fff;
  box-shadow: 5px 5px 15px 0px rgba(44, 44, 44, 0.15);
  padding: 10px;
}

.cadastro, .endereco {
  width: 60%;
  padding: 10px;
}

.cadastro2 {
  width: 70%;
  padding: 0 25% 0 0;
}

.cadastro-form {
  display: grid;
  grid-template-columns: 1fr 1fr;
  padding: 0 0 0 10px;
}

.form-left, .form-right, .form-spam {
  display: grid;
  justify-items: start;
  text-align: left;
  padding: 12px 0 0 0;
}

.form-spam {
  grid-column: span 2;
  margin: 0 0 0 0;
}

.cep {
  width: 130px !important;
}

.uf {
  width: 100px !important;
}

.bt-cadastro {
  background: #2E9189;
  margin: 20px 0;
}

.bt-cadastro:hover {
  background: #186B65;
}

.margin-top {
  margin: 25px 0 0 0;
}

.descricao {
  color: #2E9189;
  font-weight: 500;
  padding: 10px 0;
}

@media (max-width: 1000px) {
  .etapas {
    margin-top: 10px;
  }
  .etapas input {
    width: 30px;
    height: 30px;
    padding-top: 5px;
  }
  .cadastro {
    width: 98%;
    padding: 10px 2px 25px 2px;
  }
  .cadastro-form {
    grid-template-columns: 1fr;
    gap: 0;
  }
  .form-spam {
    grid-column: 1;
  }
  .login {
    width: 98%;
    justify-self: center;
    padding: 10px 0;
  }
  .bt-google, .bt-facebook {
    width: 100%;
  }
  .primeiro {
    text-align: left;
    margin: 0 0 0 5px;
  }
  .ultimo {
    text-align: right;
    margin: 0 5px 0 0;
  }
}

</style>



// WEBPACK FOOTER //
// src/views/Cadastrar.vue